export const AppInstallInterstitialPlacements = {
  HOME: "home",
  PERFORMER: "performer",
} as const;

export type AppInstallInterstitialPlacement =
  (typeof AppInstallInterstitialPlacements)[keyof typeof AppInstallInterstitialPlacements];
